import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://www.linkedin.com/in/wasiq-rashid-fsd/'
      className='link footer__link'
      target='_blank'
      rel='noreferrer'
    >
      Created By Wasiq Rashid
    </a>
  </footer>
)

export default Footer
